const TechlogiesData = [
    {
        "id": 1,
        "name": "HTML"
    },
    {
        "id": 2,
        "name": "CSS"
    },
    {
        "id": 3,
        "name": "JavaScript"
    },
    {
        "id": 4,
        "name": "MySQL"
    },
    {
        "id": 5,
        "name": "Git"
    },
    {
        "id": 6,
        "name": "Github"
    }
]

export default TechlogiesData;